import { CommitmentTypeEnum } from '@sola/schema/dotcom/cart/commitments.ts';
import { PaymentFrequencyType } from '@sola/schema/dotcom/proxy-api/transactions.ts';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';

export const MOCK_DEPARTURE_COMMITMENTS: GraphQLCommitment[] = [
  {
    amountDue: 0,
    participant: {
      birthdate: '2014-04-25',
      country: 'Colombia',
      gender: 'Female',
      globalId: '08314403',
      localId: 'CO075900062',
      name: 'Luciana',
      photoUrl:
        'https://media.ci.org/w_150/v1536346920/ChildPhotos/Published/08314403_iskbag.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2019-11-20',
      end: '2026-04-02',
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-22430001',
    internalId: 'a1oPW00000wR5NDYA0',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: '2026-03-14',
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LOt000008s0BJMAY',
    paymentPullDay: 15,
    paymentDateNext: '2026-04-16',
    rate: 43,
    receiptorId: '09090785',
    sourceCode: '595241',
    status: 'Active',
    transactionId: 'BENORD0018623129',
    _sys: {
      billingType: 'Billing',
      delinkType: 'Unplanned Exit',
      linkType: 'New Assignment',
      program: 'CDSP',
      recordType: 'Ongoing Commitments',
      subProgram: 'Sponsor',
    },
  },
  {
    amountDue: 0,
    participant: {
      birthdate: '2015-01-09',
      country: 'Colombia',
      gender: 'Female',
      globalId: '11752120',
      localId: 'CO075900118',
      name: 'Samanta',
      photoUrl:
        'https://media.ci.org/w_150/v1745524128/ChildPhotos/Published/11752120_hvhgik.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: false,
    canMakePayments: false,
    canWrite: false,
    dates: {
      start: '2026-05-07',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-22430002',
    internalId: 'a1ogP000006wfiUQAQ',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LOt000008s0BJMAY',
    paymentPullDay: 15,
    paymentDateNext: '2026-05-16',
    rate: 43,
    receiptorId: '09090785',
    sourceCode: '595241',
    status: 'Cancel Pending Sub',
    transactionId: null,
    _sys: {
      billingType: 'Billing',
      delinkType: null,
      linkType: 'Sub Assignment',
      program: 'CDSP',
      recordType: 'Ongoing Commitments',
      subProgram: 'Sponsor',
    },
  },
];

export const MOCK_COMMITMENTS_MIXED: GraphQLCommitment[] = [
  ...MOCK_DEPARTURE_COMMITMENTS,
  {
    participant: {
      birthdate: null,
      country: null,
      gender: null,
      globalId: null,
      localId: null,
      name: null,
      photoUrl: null,
    },
    commitmentType: CommitmentTypeEnum.NA,
    canGiveGifts: false,
    canMakePayments: false,
    canWrite: false,
    dates: {
      start: '2023-11-27',
      end: null,
    },
    frequency: PaymentFrequencyType.OneTime,
    fund: {
      code: null,
      description: null,
    },
    globalId: 'CN-20363889',
    internalId: 'a1oPW00000K3GO5YAN',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: null,
    paymentMethodId: null,
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 0,
    sourceCode: null,
    status: 'Closed',
    transactionId: null,
  },
  {
    participant: {
      birthdate: null,
      country: null,
      gender: null,
      globalId: null,
      localId: null,
      name: null,
      photoUrl: null,
    },
    commitmentType: CommitmentTypeEnum.FundCommitment,
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-11-18',
      end: '2025-11-18',
    },
    frequency: PaymentFrequencyType.OneTime,
    fund: {
      code: '12GW',
      description: "Bibles - Give God's Word",
    },
    globalId: 'CN-21140084',
    internalId: 'a1oOt00000YPwq2IAD',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: null,
    paymentMethodId: null,
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 96,
    sourceCode: '15138',
    status: 'Closed',
    transactionId: null,
  },
  {
    participant: {
      birthdate: null,
      country: null,
      gender: null,
      globalId: null,
      localId: null,
      name: null,
      photoUrl: null,
    },
    commitmentType: CommitmentTypeEnum.GiftCatalog,
    canGiveGifts: false,
    canMakePayments: false,
    canWrite: false,
    dates: {
      start: '2025-11-18',
      end: '2025-11-18',
    },
    frequency: PaymentFrequencyType.OneTime,
    fund: {
      code: '12LV',
      description: 'Income generation - Livestock',
    },
    globalId: 'CN-21140083',
    internalId: 'a1oOt00000YPwq1IAD',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'One-Time',
    paymentMethodId: 'a2LPW000002gWbp2AE',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 162,
    sourceCode: '15138',
    status: 'Closed',
    transactionId: 'a1oOt00000YPwq1IAD',
  },
  {
    participant: {
      birthdate: '2013-09-05',
      country: 'Colombia',
      gender: 'Female',
      globalId: '06986454',
      localId: 'CO038600221',
      name: 'Luizha',
      photoUrl:
        'https://media.ci.org/w_150/v1691598791/ChildPhotos/Published/06986454_0b98b4.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2022-08-04',
      end: '2024-02-15',
    },
    frequency: 'Annually',
    fund: {
      code: 'BG',
      description: 'Birthday Gift',
      icon: 'birthday-cake',
    },
    globalId: 'CN-16184239',
    internalId: 'a1o3b000007zrJNAAY',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: null,
    paymentMethodId: null,
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 30,
    receiptorId: '08433103',
    sourceCode: '614072',
    status: 'Closed',
    transactionId: 'T-114426071',
  },
  {
    participant: {
      birthdate: '2013-09-05',
      country: 'Colombia',
      gender: 'Female',
      globalId: '06986454',
      localId: 'CO038600221',
      name: 'Luizha',
      photoUrl:
        'https://media.ci.org/w_150/v1691598791/ChildPhotos/Published/06986454_0b98b4.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2018-10-10',
      end: '2024-02-16',
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-09078293',
    internalId: 'a1o1J000003pGcZQAU',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: false,
    lastCorrespondenceDate: '2023-12-05',
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 43,
    receiptorId: '08433103',
    sourceCode: '39472',
    status: 'Closed',
    transactionId: 'T-033886825',
  },
  {
    participant: {
      birthdate: '2019-02-21',
      country: 'Colombia',
      gender: 'Female',
      globalId: '10482135',
      localId: 'CO095400122',
      name: 'Breinys',
      photoUrl:
        'https://media.ci.org/w_150/v1699048225/ChildPhotos/Published/10482135_bcqxec.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2024-02-16',
      end: '2024-03-22',
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-18961162',
    internalId: 'a1oPW0000043ueTYAQ',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 43,
    receiptorId: '08433103',
    sourceCode: '39472',
    status: 'Closed',
    transactionId: 'T-146742026',
  },
  {
    participant: {
      birthdate: '2006-07-05',
      country: 'Haiti',
      gender: 'Female',
      globalId: '05222700',
      localId: 'HA025409326',
      name: 'Christelle',
      photoUrl:
        'https://media.ci.org/w_150/v1706539828/ChildPhotos/Published/05222700_5a88e0.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-10-27',
      end: null,
    },
    frequency: 'Annually',
    fund: {
      code: 'BG',
      description: 'Birthday Gift',
      icon: null,
    },
    globalId: 'CN-21130400',
    internalId: 'a1oOt00000XWsbmIAD',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Annually',
    paymentMethodId: 'a2LOt000009YyRBMA0',
    paymentPullDay: 1,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 30,
    receiptorId: '08433103',
    sourceCode: '667607',
    status: 'Active',
    transactionId: 'T-172144653',
  },
  {
    participant: {
      birthdate: '2006-07-05',
      country: 'Haiti',
      gender: 'Female',
      globalId: '05222700',
      localId: 'HA025409326',
      name: 'Christelle',
      photoUrl:
        'https://media.ci.org/w_150/v1706539828/ChildPhotos/Published/05222700_5a88e0.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2024-03-22',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-19101984',
    internalId: 'a1oPW0000056i8LYAQ',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: '2025-10-27',
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: 10,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 43,
    receiptorId: '08433103',
    sourceCode: '39472',
    status: 'Active',
    transactionId: 'T-165700877',
  },
  {
    participant: {
      birthdate: '2006-07-05',
      country: 'Haiti',
      gender: 'Female',
      globalId: '05222700',
      localId: 'HA025409326',
      name: 'Christelle',
      photoUrl:
        'https://media.ci.org/w_150/v1706539828/ChildPhotos/Published/05222700_5a88e0.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-08-22',
      end: null,
    },
    frequency: 'Quarterly',
    fund: {
      code: 'FG',
      description: 'Family Gift',
      icon: 'family-gift',
    },
    globalId: 'CN-21103888',
    internalId: 'a1oOt00000UKGxjIAH',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Quarterly',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 50,
    receiptorId: '08433103',
    sourceCode: '667607',
    status: 'Closed',
    transactionId: 'T-171534165',
  },
  {
    participant: {
      birthdate: '2006-07-05',
      country: 'Haiti',
      gender: 'Female',
      globalId: '05222700',
      localId: 'HA025409326',
      name: 'Christelle',
      photoUrl:
        'https://media.ci.org/w_150/v1706539828/ChildPhotos/Published/05222700_5a88e0.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-07-19',
      end: null,
    },
    frequency: 'Semi-Annually',
    fund: {
      code: 'GG',
      description: 'General Gift',
      icon: 'beneficiary',
    },
    globalId: 'CN-21089419',
    internalId: 'a1oOt00000Ryt6vIAB',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Semi-Annually',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 15,
    receiptorId: '08433103',
    sourceCode: '667606',
    status: 'Closed',
    transactionId: 'T-171474981',
  },
  {
    participant: {
      birthdate: '2006-07-05',
      country: 'Haiti',
      gender: 'Female',
      globalId: '05222700',
      localId: 'HA025409326',
      name: 'Christelle',
      photoUrl:
        'https://media.ci.org/w_150/v1706539828/ChildPhotos/Published/05222700_5a88e0.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-10-24',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'GG',
      description: 'General Gift',
      icon: null,
    },
    globalId: 'CN-21130187',
    internalId: 'a1oOt00000XS279IAD',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LOt000009YyRBMA0',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 50,
    receiptorId: '08433103',
    sourceCode: '667607',
    status: 'Closed',
    transactionId: 'T-172143758',
  },
  {
    globalId: 'CN-16857877',
    participant: {
      birthdate: '2014-12-22',
      country: 'Indonesia',
      gender: 'Male',
      globalId: '08741919',
      localId: 'IO017600065',
      name: 'Jona',
      photoUrl:
        'https://media.ci.org/w_150/v1717045808/ChildPhotos/Published/08741919_fspnhs.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2022-11-22',
      end: null,
    },
    frequency: 'Annually',
    fund: {
      code: 'BG',
      description: 'Birthday Gift',
      icon: null,
    },
    internalId: 'a1o3b000008BDKSAA4',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Annually',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: 15,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 30,
    receiptorId: '08433103',
    sourceCode: '615760',
    status: 'Active',
    transactionId: 'T-167387674',
  },
  {
    globalId: 'CN-11543478',
    participant: {
      birthdate: '2014-12-22',
      country: 'Indonesia',
      gender: 'Male',
      globalId: '08741919',
      localId: 'IO017600065',
      name: 'Jona',
      photoUrl:
        'https://media.ci.org/w_150/v1717045808/ChildPhotos/Published/08741919_fspnhs.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2019-12-11',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    internalId: 'a1o3b000006CWBSAA4',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    hasMissedPayment: true,
    lastCorrespondenceDate: '2025-10-27',
    paymentFrequency: 'Quarterly',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: 6,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 43,
    receiptorId: '08433103',
    sourceCode: '127445',
    status: 'Active',
    transactionId: 'T-171474986',
  },
  {
    participant: {
      birthdate: '2014-12-22',
      country: 'Indonesia',
      gender: 'Male',
      globalId: '08741919',
      localId: 'IO017600065',
      name: 'Jona',
      photoUrl:
        'https://media.ci.org/w_150/v1717045808/ChildPhotos/Published/08741919_fspnhs.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-09-10',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'GG',
      description: 'General Gift',
      icon: null,
    },
    globalId: 'CN-21112031',
    internalId: 'a1oOt00000VKgm5IAD',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 15,
    receiptorId: '08433103',
    sourceCode: '667607',
    status: 'Active',
    transactionId: 'T-172076709',
  },
  {
    participant: null,
    commitmentType: 'NA',
    canGiveGifts: false,
    canMakePayments: false,
    canWrite: false,
    dates: {
      start: '2018-10-23',
      end: null,
    },
    frequency: 'Annually',
    fund: {
      code: 'CF',
      description: 'Christmas Gift Program',
      icon: 'christmas-gift',
    },
    globalId: 'CN-09213735',
    internalId: 'a1o1J000003s5hyQAA',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Annually',
    paymentMethodId: null,
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 25,
    receiptorId: '08433103',
    sourceCode: '124003',
    status: 'Closed',
    transactionId: 'T-034899231',
  },
  {
    participant: null,
    commitmentType: 'NA',
    canGiveGifts: false,
    canMakePayments: false,
    canWrite: false,
    dates: {
      start: '2025-08-26',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'CF',
      description: 'Christmas Gift Program',
      icon: 'christmas-gift',
    },
    globalId: 'CN-21105757',
    internalId: 'a1oOt00000UYEkAIAX',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW00000FRtJ92AL',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 30,
    receiptorId: '08433103',
    sourceCode: '667606',
    status: 'Closed',
    transactionId: 'T-171539056',
  },
  {
    globalId: 'CN-21130401',
    participant: null,
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-10-27',
      end: null,
    },
    frequency: 'Annually',
    fund: {
      code: 'CF',
      description: 'Christmas Gift Program',
      icon: null,
    },
    internalId: 'a1oOt00000XX3P7IAL',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Annually',
    paymentMethodId: 'a2LOt000009YyRBMA0',
    paymentPullDay: 1,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 20,
    receiptorId: '08433103',
    sourceCode: '667607',
    status: 'Active',
    transactionId: 'T-172144654',
  },
  {
    participant: null,
    commitmentType: 'NA',
    canGiveGifts: false,
    canMakePayments: false,
    canWrite: false,
    dates: {
      start: '2024-12-06',
      end: null,
    },
    frequency: 'Annually',
    fund: {
      code: 'CF',
      description: 'Christmas Gift Program',
      icon: null,
    },
    globalId: 'CN-20328753',
    internalId: 'a1oPW00000JUl53YAD',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Annually',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 25,
    receiptorId: '08433103',
    sourceCode: '653114',
    status: 'Closed',
    transactionId: 'T-162261337',
  },
  {
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-10-24',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'ER',
      description: 'Disaster Relief',
      icon: 'cloud-raining-03',
    },
    globalId: 'CN-21130188',
    internalId: 'a1oOt00000XS4X7IAL',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LOt000009YyRBMA0',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 57,
    receiptorId: '08433103',
    sourceCode: '667607',
    status: 'Closed',
    transactionId: 'T-172143759',
  },
  {
    participant: null,
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-10-28',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'PG',
      description: 'Project Gift',
      icon: 'church',
    },
    globalId: 'CN-21130575',
    internalId: 'a1oOt00000XZTYnIAP',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW00000FRtJ92AL',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 75,
    receiptorId: '08433103',
    sourceCode: '667606',
    status: 'Pending',
    transactionId: 'T-172145369',
  },
  {
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-03-19',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'MF',
      description: 'Survival Intervention',
      icon: 'mom-baby',
    },
    globalId: 'CN-20720516',
    internalId: 'a1oPW00000T5JVtYAN',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 5,
    receiptorId: '08433103',
    sourceCode: '15138',
    status: 'Closed',
    transactionId: 'T-167303724',
  },
  {
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2025-05-01',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'MN',
      description: 'Where Most Needed',
      icon: 'heart-hand',
    },
    globalId: 'CN-20870528',
    internalId: 'a1oPW00000X2YkIYAV',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW00000FRtJ92AL',
    paymentPullDay: null,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 5.6,
    receiptorId: '08433103',
    sourceCode: '15138',
    status: 'Closed',
    transactionId: 'T-169213272',
  },
];
export const MOCK_COMMITMENTS_MISSED_PAYMENT: GraphQLCommitment[] = [
  {
    participant: {
      birthdate: '2006-07-05',
      country: 'Haiti',
      gender: 'Female',
      globalId: '05222700',
      localId: 'HA025409326',
      name: 'Christelle',
      photoUrl:
        'https://media.ci.org/w_150/v1706539828/ChildPhotos/Published/05222700_5a88e0.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2024-03-22',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-19101984',
    internalId: 'a1oPW0000056i8LYAQ',
    hasMissedPayment: true,
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: '2025-10-27',
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LPW000002OKFl2AO',
    paymentPullDay: 10,
    // paymentDateLast: '2025-03-16',
    paymentDateNext: '2025-04-16',
    rate: 43,
    receiptorId: '08433103',
    sourceCode: '39472',
    status: 'Active',
    transactionId: 'T-165700877',
  },
];

export const MOCK_SUPPORTER_GIFT_COMMITMENTS: GraphQLCommitment[] = [
  {
    amountDue: 43,
    participant: {
      birthdate: '2018-02-07',
      country: 'Ethiopia',
      gender: 'Male',
      globalId: '11807437',
      localId: 'ET078200031',
      name: 'Kunyajuak',
      photoUrl:
        'https://media.ci.org/w_150/v1748587336/ChildPhotos/Published/11807437_vpbvzc.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-22022640',
    internalId: 'a1ogP000005P0BeQAK',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 43,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072192',
  },
  {
    amountDue: 43,
    participant: {
      birthdate: '2021-12-28',
      country: 'Ethiopia',
      gender: 'Female',
      globalId: '11807311',
      localId: 'ET078200173',
      name: 'Dibore',
      photoUrl:
        'https://media.ci.org/w_150/v1748509300/ChildPhotos/Published/11807311_wsesiu.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-22022641',
    internalId: 'a1ogP000005P4ITQA0',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 43,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072183',
  },
  {
    amountDue: 50,
    participant: {
      birthdate: '2008-08-30',
      country: 'Ghana',
      gender: 'Male',
      globalId: '05518723',
      localId: 'GH042200247',
      name: 'Elvis',
      photoUrl:
        'https://media.ci.org/w_150/v1719823456/ChildPhotos/Published/05518723_5c9483.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2023-08-30',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'BG',
      description: 'Birthday Gift',
      icon: null,
    },
    globalId: 'CN-18001318',
    internalId: 'a1o3b000008bFnbAAE',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 50,
    receiptorId: '02089411',
    sourceCode: '615762',
    status: 'Active',
    transactionId: 'T-178072189',
  },
  {
    amountDue: 43,
    participant: {
      birthdate: '2008-08-30',
      country: 'Ghana',
      gender: 'Male',
      globalId: '05518723',
      localId: 'GH042200247',
      name: 'Elvis',
      photoUrl:
        'https://media.ci.org/w_150/v1719823456/ChildPhotos/Published/05518723_5c9483.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2022-05-19',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-15926338',
    internalId: 'a1o3b000007r9ofAAA',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: '2022-05-19',
    paymentDateNext: '2026-06-05',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 5,
    rate: 43,
    receiptorId: '02089411',
    sourceCode: '639184',
    status: 'Active',
    transactionId: 'T-178072171',
  },
  {
    amountDue: 43,
    participant: {
      birthdate: '2022-05-05',
      country: 'Haiti',
      gender: 'Male',
      globalId: '11777857',
      localId: 'HA040200249',
      name: 'Djuvensley',
      photoUrl:
        'https://media.ci.org/w_150/v1746561250/ChildPhotos/Published/11777857_sudvld.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-22022643',
    internalId: 'a1ogP000005P4S9QAK',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-05',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 5,
    rate: 43,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072186',
  },
  {
    amountDue: 0,
    participant: {
      birthdate: '2017-09-18',
      country: 'Kenya',
      gender: 'Male',
      globalId: '09539286',
      localId: 'KE021900156',
      name: 'Simintei',
      photoUrl:
        'https://media.ci.org/w_150/v1732878799/ChildPhotos/Published/09539286_rjpuxo.jpg',
    },
    commitmentType: 'GiftCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2023-08-30',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'BG',
      description: 'Birthday Gift',
      icon: null,
    },
    globalId: 'CN-18001324',
    internalId: 'a1o3b000008bFo0AAE',
    interventionId: null,
    isCorrespondent: null,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-04-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 50,
    receiptorId: '02089411',
    sourceCode: '615762',
    status: 'Active',
    transactionId: 'T-178072177',
  },
  {
    amountDue: 86,
    participant: {
      birthdate: '2017-09-18',
      country: 'Kenya',
      gender: 'Male',
      globalId: '09539286',
      localId: 'KE021900156',
      name: 'Simintei',
      photoUrl:
        'https://media.ci.org/w_150/v1732878799/ChildPhotos/Published/09539286_rjpuxo.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2021-12-09',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-15237003',
    internalId: 'a1o3b000007bN7EAAU',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-05',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 43,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 5,
    rate: 43,
    receiptorId: '02089411',
    sourceCode: '624246',
    status: 'Active',
    transactionId: 'T-178072174',
  },
  {
    amountDue: 129,
    participant: {
      birthdate: '2022-02-03',
      country: 'Rwanda',
      gender: 'Male',
      globalId: '11760746',
      localId: 'RW067700105',
      name: 'Emmanuel',
      photoUrl:
        'https://media.ci.org/w_150/v1746287928/ChildPhotos/Published/11760746_vyzycv.jpg',
    },
    commitmentType: 'ChildSponsorship',
    canGiveGifts: true,
    canMakePayments: true,
    canWrite: true,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DS',
      description: 'Child Sponsorship Support',
      icon: null,
    },
    globalId: 'CN-22022639',
    internalId: 'a1ogP000005P0GUQA0',
    interventionId: null,
    isCorrespondent: true,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 86,
    hasDueThisMonth: true,
    dueThisMonthAmount: 43,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 43,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072204',
  },
  {
    amountDue: 60,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'BC',
      description: 'Bibles For All Children',
      icon: null,
    },
    globalId: 'CN-22023407',
    internalId: 'a1ogP000005TIxxQAG',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 40,
    hasDueThisMonth: true,
    dueThisMonthAmount: 20,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 20,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178060869',
  },
  {
    amountDue: 63,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'CF',
      description: 'Christmas Gift Program',
      icon: 'christmas-gift',
    },
    globalId: 'CN-22022634',
    internalId: 'a1ogP000005P3XhQAK',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 63,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072225',
  },
  {
    amountDue: 32,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'CP',
      description: 'Critical Program Needs',
      icon: null,
    },
    globalId: 'CN-22023393',
    internalId: 'a1ogP000005TGMiQAO',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 16,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 16,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072180',
  },
  {
    amountDue: 18,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'ER',
      description: 'Disaster Relief',
      icon: 'cloud-raining-03',
    },
    globalId: 'CN-22022636',
    internalId: 'a1ogP000005OzSUQA0',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-05',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 9,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 5,
    rate: 9,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072201',
  },
  {
    amountDue: 42,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'ED',
      description: 'Education',
      icon: 'education',
    },
    globalId: 'CN-22023408',
    internalId: 'a1ogP000005TJ61QAG',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-05',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 21,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 5,
    rate: 21,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072198',
  },
  {
    amountDue: 20,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'FE',
      description: 'Emergency Food',
      icon: null,
    },
    globalId: 'CN-22022637',
    internalId: 'a1ogP000005P45ZQAS',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 10,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 10,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072216',
  },
  {
    amountDue: 76,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'HA',
      description: 'HIV/AIDS',
      icon: 'virus',
    },
    globalId: 'CN-22023397',
    internalId: 'a1ogP000005TIjRQAW',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 57,
    hasDueThisMonth: true,
    dueThisMonthAmount: 19,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 19,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178060872',
  },
  {
    amountDue: 28,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-04',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'OV',
      description: 'Highly Vulnerable Children',
      icon: 'alert-triangle',
    },
    globalId: 'CN-22023226',
    internalId: 'a1ogP000005SCHtQAO',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 14,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 14,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072195',
  },
  {
    amountDue: 88,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'IG',
      description: 'Income Generation',
      icon: null,
    },
    globalId: 'CN-22023409',
    internalId: 'a1ogP000005TJFhQAO',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 66,
    hasDueThisMonth: true,
    dueThisMonthAmount: 22,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 22,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178060866',
  },
  {
    amountDue: 22,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'DI',
      description: 'Infrastructure Development',
      icon: null,
    },
    globalId: 'CN-22022638',
    internalId: 'a1ogP000005P4APQA0',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 11,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 11,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072222',
  },
  {
    amountDue: 18,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'MV',
      description: 'Malaria Intervention',
      icon: null,
    },
    globalId: 'CN-22023395',
    internalId: 'a1ogP000005TIWXQA4',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 18,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072228',
  },
  {
    amountDue: 12,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-02',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'MA',
      description: 'Medical Assistance',
      icon: 'medical',
    },
    globalId: 'CN-22022642',
    internalId: 'a1ogP000005OzAkQAK',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 12,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072234',
  },
  {
    amountDue: 34,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'FF',
      description: 'Partners of Compassion',
      icon: null,
    },
    globalId: 'CN-22023394',
    internalId: 'a1ogP000005TITJQA4',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 17,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 17,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072231',
  },
  {
    amountDue: 15,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-04',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: '5S',
      description: 'Survival Program',
      icon: 'mom-baby',
    },
    globalId: 'CN-22023227',
    internalId: 'a1ogP000005SAj8QAG',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: true,
    lastCorrespondenceDate: null,
    paymentDateNext: '2026-06-13',
    paymentDatePending: null,
    hasMissedPayment: false,
    missedPaymentAmount: 0,
    hasDueThisMonth: false,
    dueThisMonthAmount: 0,
    paymentFrequency: 'Monthly',
    paymentMethodId: 'a2LgP000002TI6rUAG',
    paymentPullDay: 13,
    rate: 15,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072219',
  },
  {
    amountDue: 336,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'UC',
      description: 'Unsponsored Children',
      icon: 'children',
    },
    globalId: 'CN-22023396',
    internalId: 'a1ogP000005TIebQAG',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 252,
    hasDueThisMonth: true,
    dueThisMonthAmount: 84,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 84,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072207',
  },
  {
    amountDue: 92,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: 'WP',
      description: 'Water, Sanitation and Hygiene (WASH)',
      icon: 'water-faucet',
    },
    globalId: 'CN-22023410',
    internalId: 'a1ogP000005TJXRQA4',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 69,
    hasDueThisMonth: true,
    dueThisMonthAmount: 23,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 23,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072210',
  },
  {
    amountDue: 168,
    participant: null,
    commitmentType: 'FundCommitment',
    canGiveGifts: false,
    canMakePayments: true,
    canWrite: false,
    dates: {
      start: '2026-02-05',
      end: null,
    },
    frequency: 'Monthly',
    fund: {
      code: '5Y',
      description: 'Youth Development',
      icon: null,
    },
    globalId: 'CN-22023411',
    internalId: 'a1ogP000005TJijQAG',
    interventionId: null,
    isCorrespondent: false,
    isRecurring: false,
    lastCorrespondenceDate: null,
    paymentDateNext: null,
    paymentDatePending: null,
    hasMissedPayment: true,
    missedPaymentAmount: 126,
    hasDueThisMonth: true,
    dueThisMonthAmount: 42,
    paymentFrequency: 'Monthly',
    paymentMethodId: null,
    paymentPullDay: null,
    rate: 42,
    receiptorId: '02089411',
    sourceCode: '15128',
    status: 'Active',
    transactionId: 'T-178072213',
  },
];
